module.exports = __webpack_public_path__ + "img/card2.22f25224.jpeg";